import { render, staticRenderFns } from "./DiagnosticAnswerQuestion.vue?vue&type=template&id=1455d9c6&"
import script from "./DiagnosticAnswerQuestion.vue?vue&type=script&lang=js&"
export * from "./DiagnosticAnswerQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticAnswerQuestion.vue?vue&type=style&index=0&id=1455d9c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports